'use strict';


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _state = require('@/libs/state');

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['filter', 'buffer', 'items'],
    data: function data() {
        return {
            items_: [{ text: 'anick1', type: 'user' }, { text: 'anick2', type: 'user' }, { text: 'bnick3', type: 'user' }, { text: 'cnick4' }, { text: 'dnick5' }],
            selected_idx: 0
        };
    },
    computed: {
        filteredItems: function filteredItems() {
            var filterVal = (this.filter || '').toLowerCase();

            return (0, _lodash2.default)(this.items).filter(function (item) {
                var s = false;
                if (item.text.toLowerCase().indexOf(filterVal) === 0) {
                    s = true;
                }

                (item.alias || []).forEach(function (alias) {
                    if (alias.toLowerCase().indexOf(filterVal) === 0) {
                        s = true;
                    }
                });

                return s;
            }).sort(function (a, b) {
                return a.text.localeCompare(b.text);
            }).value();
        },
        filteredAndLimitedItems: function filteredAndLimitedItems() {
            var _this = this;

            return this.filteredItems.filter(function (item, itemIdx, items) {
                var numItems = items.length - 1;
                var idxFrom = _this.selected_idx - 3;
                var idxTo = _this.selected_idx + 3;
                var isInRange = false;

                if (idxFrom < 0) {
                    idxTo += -idxFrom;
                    idxFrom = 0;
                } else if (idxTo > numItems) {
                    idxFrom -= idxTo - numItems;
                    idxTo = numItems;
                }

                if (itemIdx >= idxFrom && itemIdx <= idxTo) {
                    isInRange = true;
                }

                item.idx = itemIdx;

                return isInRange;
            });
        },
        selectedItem: function selectedItem() {
            var item = this.filteredItems[this.selected_idx];
            return item || null;
        }
    },
    watch: {
        selected_idx: function watchSelectedIdx() {
            var _this2 = this;

            this.$nextTick(function () {
                var el = _this2.$el.querySelector('.kiwi-autocomplete-item--selected');
                if (!el) {
                    return;
                }

                _this2.$el.scrollTop = el.offsetTop - el.getBoundingClientRect().height * 2;
            });

            this.tempCurrentItem();
        },
        filter: function watchFilter() {
            var numItems = this.filteredAndLimitedItems.length - 1;
            if (this.selected_idx > numItems) {
                this.selected_idx = numItems;
            }
        }
    },
    mounted: function mounted() {
        this.tempCurrentItem();
    },
    methods: {
        handleOnKeyDown: function handleOnKeyDown(event) {
            var handled = false;

            var cancelKeyCodes = [13, 188, 190];

            if (cancelKeyCodes.indexOf(event.keyCode) > -1) {
                if (!this.selectedItem) {
                    this.cancel();
                } else {
                    this.selectCurrentItem();
                    if (event.keyCode === 13) {
                        event.preventDefault();
                    }
                    handled = true;
                }
            } else if (event.keyCode === 38 || event.keyCode === 9 && event.shiftKey) {
                if (this.selected_idx > 0) {
                    this.selected_idx--;
                } else {
                    this.selected_idx = this.filteredItems.length - 1;
                }

                event.preventDefault();
                handled = true;
            } else if (event.keyCode === 40 && !event.altKey || event.keyCode === 9) {
                if (this.selected_idx < this.filteredItems.length - 1) {
                    this.selected_idx++;
                } else {
                    this.selected_idx = 0;
                }

                event.preventDefault();
                handled = true;
            } else if (event.keyCode === 16) {
                handled = true;
            }

            return handled;
        },
        openQuery: function openQuery(nick) {
            var buffer = _state2.default.addBuffer(this.buffer.networkid, nick);
            _state2.default.setActiveBuffer(buffer.networkid, buffer.name);
            this.cancel();
        },
        tempCurrentItem: function tempCurrentItem() {
            var item = this.selectedItem;
            if (!item) {
                return;
            }
            this.$emit('temp', item.value || item.text, item);
        },
        selectCurrentItem: function selectCurrentItem() {
            var item = this.selectedItem;
            var value = '';

            if (item) {
                value = item.value || item.text;
            }

            this.$emit('selected', value, item);
        },
        cancel: function cancel() {
            this.$emit('cancel');
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["AutoComplete"]
window._kiwi_exports.components.AutoComplete = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AutoComplete.vue
// module id = W+RY
// module chunks = 1